<template>
    <div v-if="false"></div>
</template>
<script>
export default {
  props: {
    item: {
      required: true
    }
  },
  setup (props) {
    return {
    }
  }
}
</script>
